import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateRange, Clear, Today } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { setDateRange, setQuickFilter } from '../../../store/slices/dashboardSlice';
import { format } from 'date-fns';

const DateRangeFilter = () => {
  const dispatch = useDispatch();
  const { dateRange, quickFilter } = useSelector((state) => state.dashboard.filters);

  // ✅ FIX: Convert date strings from Redux back to Date objects
  const startDate = dateRange.start ? new Date(dateRange.start) : null;
  const endDate = dateRange.end ? new Date(dateRange.end) : null;

  const isDisabled = Boolean(quickFilter);
  const hasDateRange = startDate && endDate;

  const handleStartDateChange = (date) => {
    dispatch(setDateRange({
      start: date,
      // Ensure end date is not before the new start date
      end: (endDate && date && date > endDate) ? null : endDate,
    }));
  };

  const handleEndDateChange = (date) => {
    dispatch(setDateRange({
      start: startDate,
      end: date,
    }));
  };

  const handleClearDateRange = () => {
    dispatch(setDateRange({ start: null, end: null }));
  };

  const handleClearQuickFilter = () => {
    dispatch(setQuickFilter(''));
  };

  const formatDateRange = () => {
    // We already have Date objects, no need for try-catch or new Date()
    if (!hasDateRange) return '';
    const start = format(startDate, 'MMM dd, yyyy');
    const end = format(endDate, 'MMM dd, yyyy');
    return `${start} - ${end}`;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DateRange sx={{ color: 'primary.main', fontSize: '1rem' }} />
          <Typography 
            variant="subtitle2" 
            sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.875rem' }}
          >
            Date Range
          </Typography>
        </Box>

        {quickFilter && (
          <Chip
            size="small"
            label={`Quick: ${quickFilter.charAt(0).toUpperCase() + quickFilter.slice(1).replace('_', ' ')}`}
            color="primary"
            variant="outlined"
            onDelete={handleClearQuickFilter}
            deleteIcon={<Clear />}
            sx={{ height: 24, fontSize: '0.75rem' }}
          />
        )}

        {hasDateRange && !quickFilter && (
          <Chip
            size="small"
            label={formatDateRange()}
            color="secondary"
            variant="outlined"
            onDelete={handleClearDateRange}
            deleteIcon={<Clear />}
            sx={{ height: 24, fontSize: '0.75rem' }}
          />
        )}
      </Box>
      
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
        <DatePicker
          label="Start Date"
          // ✅ FIX: Use the parsed Date object
          value={startDate}
          onChange={handleStartDateChange}
          disabled={isDisabled}
          // ✅ FIX: Use the parsed Date object for maxDate
          maxDate={endDate || new Date()}
          format="MM/dd/yyyy"
          slotProps={{ /* Your slotProps remain the same */ }}
        />
        
        <DatePicker
          label="End Date"
          // ✅ FIX: Use the parsed Date object
          value={endDate}
          onChange={handleEndDateChange}
          disabled={isDisabled}
          // ✅ FIX: Use the parsed Date object for minDate
          minDate={startDate}
          maxDate={new Date()}
          format="MM/dd/yyyy"
          slotProps={{ /* Your slotProps remain the same */ }}
        />
      </Box>
      
      {/* Helper text section remains the same */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        {isDisabled && (
            <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic', fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Today sx={{ fontSize: '0.875rem' }} />
                Clear quick filter to enable custom date range
            </Typography>
        )}
        
        {!isDisabled && !hasDateRange && (
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                Select both start and end dates to apply custom range
            </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DateRangeFilter;

// // src/components/dashboard/FiltersBar/DateRangeFilter.jsx
// import React from 'react';
// import { Box, Typography, alpha, useTheme, Chip, IconButton } from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { DateRange, Clear, Today } from '@mui/icons-material';
// import { useSelector, useDispatch } from 'react-redux';
// import { setDateRange, setQuickFilter } from '../../../store/slices/dashboardSlice';
// import { format } from 'date-fns';

// const DateRangeFilter = () => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const { dateRange, quickFilter } = useSelector((state) => state.dashboard.filters);

//   const isDisabled = Boolean(quickFilter);
//   const hasDateRange = dateRange.start && dateRange.end;

//   const handleStartDateChange = (date) => {
//     dispatch(setDateRange({
//       start: date,
//       end: dateRange.end,
//     }));
//   };

//   const handleEndDateChange = (date) => {
//     dispatch(setDateRange({
//       start: dateRange.start,
//       end: date,
//     }));
//   };

//   const handleClearDateRange = () => {
//     dispatch(setDateRange({ start: null, end: null }));
//   };

//   const handleClearQuickFilter = () => {
//     dispatch(setQuickFilter(''));
//   };

//   const formatDateRange = () => {
//     if (!hasDateRange) return '';
//     try {
//       const start = format(new Date(dateRange.start), 'MMM dd, yyyy');
//       const end = format(new Date(dateRange.end), 'MMM dd, yyyy');
//       return `${start} - ${end}`;
//     } catch (error) {
//       return 'Invalid date range';
//     }
//   };

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <DateRange sx={{ color: 'primary.main', fontSize: '1rem' }} />
//           <Typography 
//             variant="subtitle2" 
//             sx={{ 
//               fontWeight: 600,
//               color: 'text.primary',
//               fontSize: '0.875rem'
//             }}
//           >
//             Date Range
//           </Typography>
//         </Box>

//         {/* Active filter indicators */}
//         {quickFilter && (
//           <Chip
//             size="small"
//             label={`Quick: ${quickFilter.charAt(0).toUpperCase() + quickFilter.slice(1).replace('_', ' ')}`}
//             color="primary"
//             variant="outlined"
//             onDelete={handleClearQuickFilter}
//             deleteIcon={<Clear />}
//             sx={{ height: 24, fontSize: '0.75rem' }}
//           />
//         )}

//         {hasDateRange && !quickFilter && (
//           <Chip
//             size="small"
//             label={formatDateRange()}
//             color="secondary"
//             variant="outlined"
//             onDelete={handleClearDateRange}
//             deleteIcon={<Clear />}
//             sx={{ height: 24, fontSize: '0.75rem' }}
//           />
//         )}
//       </Box>
      
//       <Box
//         sx={{
//           display: 'grid',
//           gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
//           gap: 2,
//         }}
//       >
//         <DatePicker
//           label="Start Date"
//           value={dateRange.start}
//           onChange={handleStartDateChange}
//           disabled={isDisabled}
//           maxDate={dateRange.end || new Date()}
//           format="MM/dd/yyyy"
//           slotProps={{
//             textField: {
//               size: 'medium',
//               placeholder: 'Select start date',
//               sx: {
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: 3,
//                   background: isDisabled 
//                     ? alpha(theme.palette.action.disabled, 0.1)
//                     : alpha(theme.palette.background.paper, 0.7),
//                   backdropFilter: 'blur(10px)',
//                   transition: 'all 0.3s ease',
//                   '& fieldset': {
//                     borderColor: isDisabled 
//                       ? alpha(theme.palette.action.disabled, 0.3)
//                       : alpha(theme.palette.primary.main, 0.2),
//                   },
//                   '&:hover fieldset': {
//                     borderColor: isDisabled 
//                       ? alpha(theme.palette.action.disabled, 0.3)
//                       : alpha(theme.palette.primary.main, 0.4),
//                     boxShadow: !isDisabled ? `0 0 0 4px ${alpha(theme.palette.primary.main, 0.1)}` : 'none',
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: theme.palette.primary.main,
//                     boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.2)}`,
//                   },
//                 },
//                 '& .MuiInputLabel-root': {
//                   fontWeight: 600,
//                   color: isDisabled ? 'text.disabled' : 'text.secondary',
//                 },
//                 '& .MuiInputBase-input': {
//                   color: isDisabled ? 'text.disabled' : 'text.primary',
//                 },
//               },
//             },
//             openPickerButton: {
//               sx: {
//                 color: isDisabled ? 'action.disabled' : 'primary.main',
//               },
//             },
//           }}
//         />
        
//         <DatePicker
//           label="End Date"
//           value={dateRange.end}
//           onChange={handleEndDateChange}
//           disabled={isDisabled}
//           minDate={dateRange.start}
//           maxDate={new Date()}
//           format="MM/dd/yyyy"
//           slotProps={{
//             textField: {
//               size: 'medium',
//               placeholder: 'Select end date',
//               sx: {
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: 3,
//                   background: isDisabled 
//                     ? alpha(theme.palette.action.disabled, 0.1)
//                     : alpha(theme.palette.background.paper, 0.7),
//                   backdropFilter: 'blur(10px)',
//                   transition: 'all 0.3s ease',
//                   '& fieldset': {
//                     borderColor: isDisabled 
//                       ? alpha(theme.palette.action.disabled, 0.3)
//                       : alpha(theme.palette.primary.main, 0.2),
//                   },
//                   '&:hover fieldset': {
//                     borderColor: isDisabled 
//                       ? alpha(theme.palette.action.disabled, 0.3)
//                       : alpha(theme.palette.primary.main, 0.4),
//                     boxShadow: !isDisabled ? `0 0 0 4px ${alpha(theme.palette.primary.main, 0.1)}` : 'none',
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: theme.palette.primary.main,
//                     boxShadow: `0 0 0 4px ${alpha(theme.palette.primary.main, 0.2)}`,
//                   },
//                 },
//                 '& .MuiInputLabel-root': {
//                   fontWeight: 600,
//                   color: isDisabled ? 'text.disabled' : 'text.secondary',
//                 },
//                 '& .MuiInputBase-input': {
//                   color: isDisabled ? 'text.disabled' : 'text.primary',
//                 },
//               },
//             },
//             openPickerButton: {
//               sx: {
//                 color: isDisabled ? 'action.disabled' : 'primary.main',
//               },
//             },
//           }}
//         />
//       </Box>
      
//       {/* Helper text */}
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
//         {isDisabled && (
//           <Typography 
//             variant="caption" 
//             sx={{ 
//               color: 'text.secondary',
//               fontStyle: 'italic',
//               fontSize: '0.75rem',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.5,
//             }}
//           >
//             <Today sx={{ fontSize: '0.875rem' }} />
//             Clear quick filter to enable custom date range
//           </Typography>
//         )}
        
//         {!isDisabled && !hasDateRange && (
//           <Typography 
//             variant="caption" 
//             sx={{ 
//               color: 'text.secondary',
//               fontSize: '0.75rem',
//             }}
//           >
//             Select both start and end dates to apply custom range
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default DateRangeFilter;
